import React, { createContext, useState, useContext, useEffect } from 'react';

const BrandingContext = createContext(null);

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBranding = async () => {
      try {
        const response = await fetch('/api/public/branding');
        if (response.ok) {
          const data = await response.json();
          setBranding(data);
        } else {
          setBranding({});
        }
      } catch (e) {
        console.error('Ошибка загрузки брендинга:', e);
        setBranding({});
      } finally {
        setLoading(false);
      }
    };
    fetchBranding();
  }, []);

  // Обновляем document.title при загрузке брендинга: «Название сервиса - Панель управления»
  useEffect(() => {
    if (!branding || loading) return;
    const name = (branding.site_name || '').trim();
    document.title = name ? `${name} - Панель управления` : 'Панель управления';
  }, [branding, loading]);

  const value = { branding, brandingLoading: loading };
  return (
    <BrandingContext.Provider value={value}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => {
  const ctx = useContext(BrandingContext);
  return ctx || { branding: null, brandingLoading: true };
};
